/**
 * Support-chat identity contract.
 *
 * Payload handed to the Bitrix24 live-chat widget so a logged-in customer stops
 * being an anonymous guest. `customData` is intentionally loosely typed: it is
 * Bitrix24's own block format (USER / GRID), not our domain — its shape is
 * pinned by unit tests on the builder, not by this schema.
 */
import { z } from 'zod/v4';

export const supportChatIdentitySchema = z.object({
  hash: z.string().regex(/^[0-9a-f]{32}$/),
  orgId: z.string().uuid(),
  name: z.string().min(1),
  lastName: z.string().optional(),
  email: z.string().email(),
  avatar: z.string().url().optional(),
  position: z.string().optional(),
  customData: z.array(z.record(z.string(), z.unknown())),
});

export type SupportChatIdentity = z.infer<typeof supportChatIdentitySchema>;
